function setAccordionPanelOpen(btn, panel, isOpen) {
    btn.classList.toggle('is-open', isOpen);
    panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0';
}

function refreshAccordionPanel(panel) {
    const btn = panel.closest('[data-accordion-item]')?.querySelector('[data-accordion-trigger]');
    if (btn?.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
    }
}

document.querySelectorAll('.accordion-panel').forEach((panel) => {
    let btn = panel.querySelector('.accordion-panel__header');
    if (btn) {
        btn.addEventListener('click', () => {
            panel.classList.toggle('is-open');
        });
    }
});

document.querySelectorAll('[data-accordion]').forEach((acc) => {
    const multiple = acc.dataset.accordion === 'multiple';

    acc.querySelectorAll('[data-accordion-item]').forEach((item) => {
        const btn = item.querySelector('[data-accordion-trigger]');
        const panel = item.querySelector('[data-accordion-panel]');

        if (item.hasAttribute('data-accordion-default-open')) {
            setAccordionPanelOpen(btn, panel, true);
        }

        btn.addEventListener('click', () => {
            const isOpen = btn.classList.contains('is-open');

            if (!multiple) {
                acc.querySelectorAll('[data-accordion-trigger].is-open').forEach((b) => {
                    if (b === btn) {
                        return;
                    }

                    b.classList.remove('is-open');
                    b.closest('[data-accordion-item]').querySelector('[data-accordion-panel]').style.maxHeight = '0';
                });
            }

            setAccordionPanelOpen(btn, panel, !isOpen);
        });
    });
});

window.refreshAccordionPanel = refreshAccordionPanel;
